import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, LogOut, Clock } from 'lucide-react';
import { ROUTE_PATHS } from '@/lib/index';
import { Button } from '@/components/ui/button';
import { fadeInUp } from '@/lib/motion';

export default function MemberZone() {
  const navigate = useNavigate();

  // Auth check — any logged-in user can access member zone
  useEffect(() => {
    const role = sessionStorage.getItem('hktcm_role');
    if (!role) {
      navigate(ROUTE_PATHS.MEMBER_LOGIN);
    }
  }, [navigate]);

  function handleLogout() {
    sessionStorage.removeItem('hktcm_role');
    sessionStorage.removeItem('hktcm_user');
    navigate(ROUTE_PATHS.MEMBER_LOGIN);
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-emerald-50 flex flex-col">
      {/* Header */}
      <header className="bg-background/90 backdrop-blur-md border-b border-border px-4 py-4 sticky top-0 z-30">
        <div className="container mx-auto flex items-center justify-between">
          <Link to={ROUTE_PATHS.HOME} className="flex items-center gap-3">
            <img
              src="/images/hkcmprgu-logo-01.png"
              alt="香港中醫師權益總工會"
              className="h-10 w-auto"
            />
            <span className="text-lg font-bold text-primary hidden sm:inline">
              會員專區
            </span>
          </Link>
          <div className="flex items-center gap-3">
            <Link to={ROUTE_PATHS.HOME}>
              <Button variant="ghost" size="sm" className="gap-2">
                <ArrowLeft className="h-4 w-4" />
                返回主頁
              </Button>
            </Link>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              className="gap-2 text-destructive hover:text-destructive hover:bg-destructive/10"
            >
              <LogOut className="h-4 w-4" />
              登出
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <motion.div
          className="text-center max-w-md mx-auto"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
              <Clock className="w-10 h-10 text-primary" />
            </div>
          </div>
          <h1 className="text-2xl font-bold text-foreground mb-4">
            會員專區
          </h1>
          <p className="text-lg text-muted-foreground leading-relaxed">
            會員專區將盡快完成並提供服務！
          </p>
          <p className="text-sm text-muted-foreground mt-3">
            如有查詢，請電郵至{' '}
            <a
              href="mailto:inquiry@hktcmpu.org.hk"
              className="text-primary hover:underline"
            >
              inquiry@hktcmpu.org.hk
            </a>
          </p>
        </motion.div>
      </main>
    </div>
  );
}
